// extracted by css-extract-rspack-plugin
export default {"modalBody":"PEThnn5NoaUTeYTo","alertList":"Crevla6pcAs8_y1K","section":"Reqbnitie6IQhdEg","sectionHeader":"aXolWM1bXX0LeRz_","shipExplanation":"d5fMUQQcBQzxLcSm"};